import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useHistory } from 'react-router-dom';
import axios from 'axios';
import 'react-toastify/dist/ReactToastify.css';

toast.configure();
const AddLectureForm = ({ id }) => {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [url, setUrl] = useState('');

  let history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    var bodyFormData = new FormData();
    bodyFormData.append('section_id', id);
    bodyFormData.append('title', title);
    bodyFormData.append('overview', description);
    bodyFormData.append('video_url', url);
    // posting data
    const uname = JSON.parse(localStorage.getItem('uname'));
    const URL = `https://stucharge.bakersbrisk.com/api/lectureapi?username=${uname}&id=${id}`;
    const AuthStr = process.env.REACT_APP_AUTH_STR;
    // send lecture data to server
    axios
      .post(URL, bodyFormData, {
        headers: { Authorization: AuthStr },
      })
      .then(function (response) {
        if (response.status === 201)
          toast.success('Lecture added successfully!');
        history.push('/home');
        history.push(`/courses/section/${id}`);
      })
      .catch((error) => {
        toast.error('Something went wrong, please try again');
      });
  };

  return (
    <form className='class-form' onSubmit={(e) => handleSubmit(e)}>
      <div className='form-control'>
        <label htmlFor='title'>Lecture Title</label>
        <input
          type='text'
          value={title}
          required
          onChange={(e) => setTitle(e.target.value)}
        />
      </div>
      <div className='form-control'>
        <label htmlFor='item'>Description</label>
        <textarea
          type='text'
          value={description}
          required
          onChange={(e) => setDescription(e.target.value)}
        ></textarea>
      </div>
      <div className='form-control'>
        <label htmlFor='url'>Video Url</label>
        <input
          type='url'
          value={url}
          required
          onChange={(e) => setUrl(e.target.value)}
        />
      </div>
      <button type='submit' className='btn'>
        Add Lecture
      </button>
    </form>
  );
};

export default AddLectureForm;
